import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FalLiteComponent } from './fal-lite.component';

export const routes: Routes = [{ path: '', component: FalLiteComponent, data: { title: 'csh.fal.lite.home' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FalLiteRoutingModule {}
